import { InputHTMLAttributes } from 'react';
import { useFormContext } from 'react-hook-form';
import SearchIcon from '@app/assets/icons/search.svg?react';
import clsx from 'clsx';
import { debounce } from 'lodash';

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  containerClass?: string;
  externalHandler?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchInput = ({
  name,
  containerClass,
  externalHandler,
  ...rest
}: SearchInputProps) => {
  const {
    register,
    trigger,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={`w-full ${containerClass ?? ''}`}>
      <div className="relative">
        <input
          {...rest}
          {...register(name ?? '')}
          onChange={debounce((e) => {
            register(name ?? '').onChange(e);

            if (externalHandler) {
              externalHandler(e);
            }
            // trigger validation only after typing stops
            if (name) void trigger(name as any);
          }, 500)}
          className={clsx(
            'w-96 bg-transparent border-b border-gray-300 py-2 pr-10 outline-none placeholder:text-gray-400 text-gray-700 transition-colors focus:border-gray-500',
            rest.className ?? ''
          )}
        />
        <SearchIcon className="absolute right-0 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
      </div>
      {name && errors[name] && (
        <p role="alert" className="text-system-error text-sm text-left pt-1">
          {typeof errors?.[name]?.message === 'string'
            ? errors[name]?.message
            : ''}
        </p>
      )}
    </div>
  );
};
